// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-cell-trucate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 30px;
  font-size: 12px;
}

.table-cell-home-OrgDisplayName {
  padding-left: 30px;
  flex-direction: column;
  padding-top: 5px;
  font-size: 12px;
  display: flex;
  align-items: flex-start;
  gap: 2px;
}

.table-cell-orgName {
  margin: 0px !important;
  white-space: nowrap;
  overflow: hidden;
  max-width: 200px;
  text-overflow: ellipsis;
}
.orgName-column-header {
  padding-left: 40px !important;
}
.MuiDataGrid-cell {
  font-size: 14px !important;
}
.MuiStepLabel-label {
  font-size: 14px !important;
}
.welcome-message {
  /* display: flex;
  align-items: center; */
  max-width: 100%;
  margin-bottom: 1.2rem;
  margin-left: 2px;
}
.circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  font-size: 8px;
  color: #ff0000;
  border: 2px solid #ff0000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-tooltip {
  display: inline-block;
  width: 15px;
  height: 15px;
  background-color: #ff0000;
  border-radius: 50%;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 16px;
  position: relative;
}
.welcome-message span {
  font-size: 14px;
  font-weight: 500;
}

.instruction-icon {
  display: inline-block;
  cursor: pointer;
  padding: 0;
  border: none;
  background: none;
}
.approvalReq-Icon {
  color: #008080;
}
.instruction-icon-svg {
  color: #008080;
  height: 1.5em !important;
  width: 2rem !important;
}
/* .instruction-icon-svg:hover {
  color: #015858;
  height: 1.5em !important;
  width: 2.3rem !important;
  transition: 1s ease;
} */
.bullet {
  margin-bottom: 5px;
}
.dashboard-instructions {
  padding: 5px;
  font-size: 12px;
  font-family: "Open Sans" !important;
}
.dashboard-instructions-header {
  font-size: 12px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/HomeDashboard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;wBACsB;EACtB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,sBAAsB;AACxB;AACA;;;;;GAKG;AACH;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".table-cell-trucate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 30px;\n  font-size: 12px;\n}\n\n.table-cell-home-OrgDisplayName {\n  padding-left: 30px;\n  flex-direction: column;\n  padding-top: 5px;\n  font-size: 12px;\n  display: flex;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.table-cell-orgName {\n  margin: 0px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 200px;\n  text-overflow: ellipsis;\n}\n.orgName-column-header {\n  padding-left: 40px !important;\n}\n.MuiDataGrid-cell {\n  font-size: 14px !important;\n}\n.MuiStepLabel-label {\n  font-size: 14px !important;\n}\n.welcome-message {\n  /* display: flex;\n  align-items: center; */\n  max-width: 100%;\n  margin-bottom: 1.2rem;\n  margin-left: 2px;\n}\n.circle {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  font-size: 8px;\n  color: #ff0000;\n  border: 2px solid #ff0000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.circle-tooltip {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  background-color: #ff0000;\n  border-radius: 50%;\n  font-size: 12px;\n  color: #fff;\n  text-align: center;\n  line-height: 16px;\n  position: relative;\n}\n.welcome-message span {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.instruction-icon {\n  display: inline-block;\n  cursor: pointer;\n  padding: 0;\n  border: none;\n  background: none;\n}\n.approvalReq-Icon {\n  color: #008080;\n}\n.instruction-icon-svg {\n  color: #008080;\n  height: 1.5em !important;\n  width: 2rem !important;\n}\n/* .instruction-icon-svg:hover {\n  color: #015858;\n  height: 1.5em !important;\n  width: 2.3rem !important;\n  transition: 1s ease;\n} */\n.bullet {\n  margin-bottom: 5px;\n}\n.dashboard-instructions {\n  padding: 5px;\n  font-size: 12px;\n  font-family: \"Open Sans\" !important;\n}\n.dashboard-instructions-header {\n  font-size: 12px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
